import React, { Component } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import LoadField from '../components/LoadField';
import MoneyField from '../components/MoneyField';

import { formatMoney } from '../utils/utils.js';

const tjtMontemar = require(`../assets/${process.env.PAGE}/img/tjt_mtm.png`);
const tjtMc = require(`../assets/${process.env.PAGE}/img/tjt_mc.png`);
require(`../assets/${process.env.PAGE}/css/components/Summary.css`);

import axios from 'axios';

class MontemarSummary extends Component {

    constructor(props) {
        super(props);
        this.state = {

            requested_amount: null,
            requested_quotas: null,
            total_amount: null,
            quota_amount: null,
            interest: null,
            interest_tax: null,
            first_payment_date: null,
            monthly_discount: null,
            package_comission: null,
            credit_cards: []
        };
    }

    componentDidMount() {

        const ROOT_URL = process.env.API_URL;
        var config = {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
            }
        };

        axios.get(`${ROOT_URL}/leads/details`, config)
            .then(res => {
                const data = res.data;
                let total_amount = data.requested_quotas * data.quota_amount;
                let interest_tax = ((total_amount - data.requested_amount) * 0.21) / 1.21
                let interest = (total_amount - data.requested_amount) - interest_tax;
                this.setState({
                    ...this.state,
                    requested_amount: data.requested_amount,
                    requested_quotas: data.requested_quotas,
                    quota_amount: data.quota_amount,
                    total_amount: data.total_amount,
                    interest: data.interest,
                    interest_tax: data.interest_tax,
                    first_payment_date: data.first_payment_date,
                    package_comission: data.package_comission,
                    monthly_discount: data.monthly_discount,
                    credit_cards: data.credit_card_offers,
                })
            }
        );
    }

    render() {
        const { credit_cards } = this.state
        const creditCardsComponent = credit_cards.map((card, index) => {
            return (
                <div key={index}>
                    <div className={'credit-card-img'}>
                        <img src={card.type === 'mc' ? tjtMc : tjtMontemar}/>
                    </div>
                    <div className={'credit-card-amount'}>
                        <span>{`Tarjeta ${card.type === 'mc' ? 'Mastercard' : 'Montemar'}`}</span>
                        <p>Sin cargo de mantenimiento ni renovación.</p>
                    </div>
                </div>
            );
        })
        return (
            <div className="summary text-center">
                <div className="summary_details">
                    <h4> Resumen de tu solicitud </h4>
                    <h4> Prestamo Personal </h4>
                    <div className="summary_line"></div>
                    <Row className="summary_row summary_row_vertical_align">
                        <moneyField/>
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Monto del Préstamo: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.requested_amount && (<MoneyField>{ this.state.requested_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Valor de la cuota: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                { this.state.quota_amount && (<MoneyField>{ this.state.quota_amount }</MoneyField>) }
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Cuotas: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                {this.state.requested_quotas}
                            </LoadField>
                        </Col>
                    </Row>
                    {credit_cards.length > 0 ? (<h4> Tarjetas </h4>) : ''}
                    <div className="summary_line"></div>
                    <Row className="summary_row summary_row_vertical_align">
                        <Col xs={12} md={12} lg={12}>{creditCardsComponent}</Col>
                    </Row>
                    <h4> Paquete Aprobado: Plus </h4>
                    <div className="summary_line"></div>
                    <Row className="summary_row summary_row_vertical_align">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Comisión del paquete: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField style={{marginRight: '5px'}}>
                                {this.state.package_comission && `${formatMoney(this.state.package_comission, 2, ',', '.')} `}
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row summary_row_vertical_align">
                        <Col className="summary_col text-left" xs={6} md={6} lg={6}>Bonificación mensual: </Col>
                        <Col className="summary_col text-right" xs={6} md={3} lg={6}>
                            <LoadField>
                                {this.state.monthly_discount && `${formatMoney(this.state.monthly_discount, 2, ',', '.')}*`}
                            </LoadField>
                        </Col>
                    </Row>
                    <Row className="summary_row summary_row_vertical_align">
                        <Col xs={12} md={12} lg={12} className={'text-center'}>
                            *Ver legales de la bonificación mensual
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default MontemarSummary;



/** WEBPACK FOOTER **
 ** ./src/components/MontemarSummary.js
 **/